var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeviceFixed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30774 3.54297C7.62058 3.54297 7.06409 4.0986 7.06409 4.7847V18.3852C7.06409 18.7879 7.29164 19.1557 7.65212 19.3356L9.74515 20.457H15.256L17.349 19.3356C17.7095 19.1557 17.937 18.7879 17.937 18.3852V4.7847C17.937 4.0986 17.3805 3.54297 16.6934 3.54297H8.30774Z",
    fill: "#5A6571"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42944 6.22778V15.4418H16.5695V6.22778H8.42944Z",
    fill: "#E8EFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0968 4.58112H10.902C10.7612 4.58112 10.6475 4.69472 10.6475 4.83531C10.6475 4.9759 10.7612 5.0895 10.902 5.0895H14.0968C14.2376 5.0895 14.3514 4.9759 14.3514 4.83531C14.3514 4.69472 14.2376 4.58112 14.0968 4.58112Z",
    fill: "#49545B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3803 17.0873H11.6185C11.2354 17.0873 10.9257 17.3977 10.9257 17.779C10.9257 18.1603 11.2366 18.4707 11.6185 18.4707H13.3803C13.7633 18.4707 14.0731 18.1603 14.0731 17.779C14.0731 17.3977 13.7622 17.0873 13.3803 17.0873Z",
    fill: "#40B4F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21011 17.2267H8.2954C8.15666 17.2267 8.04419 17.339 8.04419 17.4775V17.5146C8.04419 17.6531 8.15666 17.7654 8.2954 17.7654H9.21011C9.34885 17.7654 9.46132 17.6531 9.46132 17.5146V17.4775C9.46132 17.339 9.34885 17.2267 9.21011 17.2267Z",
    fill: "#49545B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7888 17.7643H16.7035C16.8422 17.7643 16.9547 17.652 16.9547 17.5135V17.4764C16.9547 17.3379 16.8422 17.2256 16.7035 17.2256H15.7888C15.6501 17.2256 15.5376 17.3379 15.5376 17.4764V17.5135C15.5376 17.652 15.6501 17.7643 15.7888 17.7643Z",
    fill: "#49545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeviceFixed);
export default __webpack_public_path__ + "static/media/ic-device-fixed.aa8e6f75fb84f39fc726808231e7e199.svg";
export { ForwardRef as ReactComponent };